import axios from "axios";
import { getAccessToken } from "./okta-config";
import { API_ROOT } from "../constants/constant";

export const getDataWAuth = (url, params = {}) => {
  return callApi(url, params, "get");
};

export const downloadDataWAuth = async (url, filename) => {
  const response = await axios.get(url, {
    headers: { Authorization: `Bearer ${getAccessToken()}` },
    responseType: "blob",
  });
  const mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  if (response.status !== 200 || !(response.data instanceof Blob) || response.data.size === 0
      || response.headers["content-type"]?.split(";")[0].trim() !== mimeType) {
    throw new Error("Failed to download template");
  }
  saveDownloadBlob(response.data, filename);
};

/** @param {Blob} blob @param {string} filename */
const saveDownloadBlob = (blob, filename) => {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  try {
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
  }
};

/** @param {string} url @param {File} file @returns {Promise<import('axios').AxiosResponse>} */
export const uploadManualRequests = (url, file) => {
  const data = new FormData();
  data.append("file", file);
  return axios.post(url, data, {
    headers: { Authorization: `Bearer ${getAccessToken()}` },
  });
};

/** @param {{ filename: string, mediaType: string, base64: string }} report */
export const downloadManualRequestErrors = (report) => {
  const mediaType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  if (!report || report.mediaType !== mediaType || typeof report.base64 !== "string" || !report.base64.length) {
    throw new Error("The upload result workbook is unavailable.");
  }
  const bytes = Uint8Array.from(window.atob(report.base64), (character) => character.charCodeAt(0));
  if (!bytes.length) {
    throw new Error("The upload result workbook is empty.");
  }
  const filename = /^[\w.-]+\.xlsx$/.test(report.filename || "") ? report.filename : "manual_request_upload_result.xlsx";
  saveDownloadBlob(new Blob([bytes], { type: mediaType }), filename);
};

export const deleteDataWAuth = (url, params = {}) => {
  return callApi(url, params, "delete");
};

export const postDataWAuth = (url, data, params = {}) => {
  return callApi(url, params, "post", data);
};

export const postDataWAuthFile = (url, data, params = {}) => {
  return callApiForFile(url, params, "post", data);
};

export const putDataWAuth = (url, data, params = {}) => {
  return callApi(url, params, "put", data);
};

export const getData = (url) =>
  fetch(url)
    .then((resp) => resp.json())
    .catch((e) => console.log(e));

const callApi = (url, params, method, data) => {
  const accessToken = getAccessToken();

  const headers = {
    "Access-Control-Allow-Origin": API_ROOT,
    Authorization: `Bearer ${accessToken}`,
  };

  return axios({ method, url, data, headers, params })
    .then((response) => {
      if (response.status === 200 || response.status === 202 || response.status === 204) {
        // For 204 No Content, return response with empty data
        if (response.status === 204) {
          return { ...response, data: response.data || [] };
        }
        return response;
      } else {
        console.log("Error Loading data !");
        return null;
      }
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const callApiForFile = (url, params, method, data) => {
  const accessToken = getAccessToken();

  const headers = {
    "Access-Control-Allow-Origin": API_ROOT,
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "multipart/form-data",
  };

  const formData = new FormData();
  formData.append("file", data);

  return axios({ method, url, data: formData, headers, params })
    .then((response) => {
      if (response.status === 200) {
        return response;
      } else {
        console.log("Error Loading data !");
        return null;
      }
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};
